export default {
  Ebay: 'platformSources.Ebay',
  Shopify: 'platformSources.Shopify',
  NA: 'platformSources.NA',
  BigCommerce: 'platformSources.BigCommerce',
  Magento: 'platformSources.Magento',
  ShipStation: 'platformSources.ShipStation',
  Amazon: 'platformSources.Amazon',
  WooCommerce: 'platformSources.WooCommerce',
  API: 'platformSources.API',
  BackerKit: 'platformSources.BackerKit',
  ShipBob: 'platformSources.ShipBob',
  CrateJoy: 'platformSources.CrateJoy',
  Stitchlabs: 'platformSources.Stitchlabs',
  QuickBooks: 'platformSources.QuickBooks',
  ExcelUpload: 'platformSources.ExcelUpload',
  Walmart: 'platformSources.Walmart',
  TicTail: 'platformSources.TicTail',
  SquareSpace: 'platformSources.SquareSpace',
  WooCommerceV2: 'platformSources.WooCommerceV2',
  SquareConnect: 'platformSources.SquareConnect',
  Returnly: 'platformSources.Returnly',
  Sps: 'platformSources.Sps'
}
